import { render, staticRenderFns } from "./CuentaBancoCompleto.vue?vue&type=template&id=a0789f5a"
import script from "./CuentaBancoCompleto.vue?vue&type=script&lang=js"
export * from "./CuentaBancoCompleto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports